// Shared number formatting for CCAANZ money displays and printouts.
//   • no `$` sign · en-NZ thousands separator
//   • negatives in accountancy parens: (1,234)
//   • em-dash for missing/NaN values

/** Format a number NZ-style: thousands-separated, negatives in accountancy
 *  parens, em-dash for null/undefined/NaN. Rounds to whole dollars. */
export const fmt = (n: number | null | undefined): string => {
  if (n === null || n === undefined || Number.isNaN(n)) return '—';
  const r = Math.round(n);
  const abs = Math.abs(r).toLocaleString('en-NZ');
  return r < 0 ? `(${abs})` : abs;
};
